import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot } from '@fortawesome/free-solid-svg-icons';
import { useAdvert } from './hooks/useAdvert';
import { getCurrentAdvertId } from './utils/getCurrentAdvertId';
import { useTranslate, useFormatDate } from '../../translations';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import { Autoplay } from 'swiper/modules';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import { ThemeSwitch } from '../../components/ThemeSwitch';

interface JobOfferProps {
  showDetails?: boolean;
}

const List = ({ title, items }: { title: string; items: string[] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className="mb-5">
      <h6 className="fw-bold">{title}</h6>
      <ul className="text-muted mb-5">
        {items.map((item, index) => (
          <li key={index} className="mb-2">
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export const JobOffer = ({ showDetails = true }: JobOfferProps) => {
  const translator = useTranslate();
  const formatDate = useFormatDate();
  const { advert } = useAdvert(getCurrentAdvertId());

  return (
    <div>
      <h1 className="fs-4 fw-bold text-primary mb-3 d-flex align-items-center justify-content-between gap-3">
        {advert.name}
        <span className="fs-6">
          <ThemeSwitch />
        </span>
      </h1>
      <span>
        <FontAwesomeIcon className="me-2 text-primary" icon={faLocationDot} />
        {advert.placeOfWork}
      </span>
      <p className="text-muted mt-4">{advert.partner}</p>
      {showDetails && (
        <>
          {advert.image.length > 0 && (
            <Swiper loop autoplay={{ delay: 2500, pauseOnMouseEnter: true }} autoHeight modules={[Autoplay]}>
              {advert.image
                .filter((image) => !!image.normal)
                .map((image, index) => (
                  <SwiperSlide key={index}>
                    <img className="img-fluid mb-4 w-100" src={image.normal} alt="work_logo" />
                  </SwiperSlide>
                ))}
            </Swiper>
          )}
          <List title={translator('tasks')} items={advert.tasks} />
          <List title={translator('expectations')} items={advert.expectations} />
          <List title={translator('advantages')} items={advert.advantages} />
          <List title={translator('what_offer')} items={advert.offer} />
          {advert.expiryDate && (
            <p className="text-center">
              {translator('application_deadline')}:{' '}
              <span className="fw-bold text-primary">
                {formatDate(advert.expiryDate, {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric',
                })}
              </span>
            </p>
          )}
        </>
      )}
    </div>
  );
};
